module.exports = __webpack_public_path__ + "static/solo-send-invoice-da72ce0cc8d860d5ac9cf75f0757ae9e.png";